export default __webpack_public_path__ + "static/media/B_Baleia.d7b4538b.svg";